import { useState, useEffect } from "react";

export function useNavigation(session) {
  const [page, setPage] = useState(() => {
    // If returning from a successful Stripe report export, land on the Reports page
    if (new URLSearchParams(window.location.search).get("export_success") === "1") {
      return "Reports";
    }
    const hash = window.location.hash.slice(1);
    const valid = ["Dashboard","Tenants","Properties","Payments","Maintenance","Financials","Documents","Settings","Team","Communications"];
    return valid.includes(hash) ? hash : "Dashboard";
  });
  const [showMoreMenu, setShowMoreMenu] = useState(false);

  useEffect(() => {
    // Only reflect the page in the hash once the user is authenticated —
    // avoids /app#Dashboard appearing in the URL for logged-out visitors.
    // Skip entirely on /admin — writing hashes there pollutes browser history
    // and causes the back button to clear the (memory-only) admin token.
    if (!session) return;
    if (window.location.pathname.startsWith("/admin")) return;
    if (!window.location.hash.includes('access_token')) {
      window.location.hash = page;
    }
  }, [page, session]);

  return { page, setPage, showMoreMenu, setShowMoreMenu };
}
